import React,{useState,useEffect} from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Basic from "./reactScheduler/Basic";
import TableData from "./Table/TableData"
import TableDataissues from "./Table/TableDataissues";
import TableDataDeadlines from "./Table/TableDataDeadlines";
import Chart from "react-apexcharts";
import { getAuthorization } from "../../axios/AxiosAut";

function ManagementDashboard(props) {


  const [Data, setData] = useState<any>([]);
  const [Issues, setIssues] = useState<any>([]);

  const [NearDeadline, setNearDeadline] = useState<any>([]);

  const [Onschedule, setOnschedule] = useState<any>([]);

  const getData = () => {
    getAuthorization()
      .get(`dashboard/management/get_schedule_statistics/`)
      .then((res) => {
        console.log("schulr stat data", res.data
        );
        setData(res.data);
        setIssues(res.data.issues?.percentage)
        setNearDeadline(res.data.near_deadline?.percentage)
        setOnschedule(res.data.on_schedule?.percentage)
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getData();
    console.log("schulr stat data.....", Data);
  }, []);

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  }));
  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Poppins",
        position: "right",
        horizontalAlign: "center",

        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },

      title: {
        text: `${Data?.total_items}`,
        align: "center",
        margin: 10,
        offsetX: -72,
        offsetY: 115,
        floating: false,
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Items",
        align: "center",
        margin: 10,
        offsetX: -72,
        offsetY: 145,
        floating: false,
        style: {
          fontSize: "16px",
          fontWeight: "300",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Issues", "On Schedule", "Near Deadline"],
      colors: ["#E40000", "#06E07F", "#EFCA09"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [Issues,Onschedule,NearDeadline],
  };
  const classes = useStyles();

  console.log("Dashboard props", props);
  return (
    <div>
      <div>
        <h2 className="font-Montserrat text-xl font-bold text-black">
          Management Dashboard
        </h2>
        <div className="border-b-2 border-blue-200 w-20"></div>
      </div>
      <Basic/>
      <div className="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableDataDeadlines />
          </div>
      </div>
      <div className="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableData />
          </div>
      </div>

      <div className="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableDataissues />
          </div>
      </div>
      <div className="mt-1">
        <div className=" shadow-slate-400 shadow-md bg-white rounded-lg flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-xl font-semibold ml-6 font-Montserrat"> Schedules</h3>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="flex-1 flex-wrap ">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="380"
              />
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="flex p-22 mt-2">
                <div className=" text-center w-fit align-middle  cursor-pointer pb-2">
                  <div className="flex">
                    <p className="ml-5 font-bold  text-red-700"> A Grade</p>
                  </div>
                  <p className=" text-lg text-black ml-4"> {Data?.issues?.total_job} items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-1  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-yellow">
                      {" "}
                      B Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4"> {Data?.on_schedule?.total_job} items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-6  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-green-500">
                      {" "}
                      C Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4">{Data?.near_deadline?.total_job} items</p>
                </div>
              </div>
              <div className="relative pt-1 px-12 mt-2">
                <div className="flex text-lg ">
                  <p className="font-bold text-2xl ml-2 mr-3">{Data?.total_items} </p> Total
                </div>
                <div className="overflow-hidden h-6 mb-4 text-xs flex rounded-2xl bg-yellow">
                  <div
                    style={{ width: `${Issues}%` }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                  ></div>
                  <div
                    style={{ width: `${NearDeadline}%` }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      

    </div>
  );
}

export default ManagementDashboard;
